export class FamilyHistory
{
    age: string;
    ageAtOnset: string;
    familyHistoryDiagnosisDescription: string;
    familyHistoryId: string;
    isDeceased: string;
    modifiedDate: string;
    name: string;
    recounciledData: string;
    relationship: string;
}

export class SaveFamilyHXRequest
{
    familyHistorystructureReconcileId: string;
    patientAccount: string;
    practiceCode: string;
    realtionShip: string;
    name: string;
    age: string;
    isDeceased: string = "0";
    ageAtOnSet: string;
    validUserId: string;
    diagnosisList:  FamilyHxDiagnosisList[] = [];
}

export class FamilyHxDiagnosisList
{
    icdTenCODE: string;
    icdTenDescription: string;
    icdNineCode: string;
    icdNineDescription: string;
    snomedDescription: string;
}


export class Relation 
{       
    val: string;      
    label: string;      
}

export class DiagnosisSearch {
    PatientAccount: string;
    PracticeCode: string;
    Query: string;
    PaginationSize: string;
    EndTo: string;
}

export class DiagnosisSearchResponse {
    CoreId: string;
    DIAG_EFFECTIVE_DATE: string;
    DIAG_EXPIRY_DATE: string;
    Favorites: string;
    ICD9CodeDescription: string;
    ICD9_CODE: string;
    ICD10_CODE: string;
    ICD10_DESCRIPTION: string;
    ICD_MAIN_CODE_EXCLUSION1: string;
    ICD_MAIN_CODE_EXCLUSION2: string;
    ICD_MAIN_CODE_INCLUSION_SINGLE: string;
    ICDs_Synonyms_Data: string;
    MOSTUSED: string;
    MyListId: string;
}
export class CommonDiseaseResponse {
  diseaseId: any;
  diseaseDescription: any;
  icD10Code: any;
  isExpired: any;

}

export class DeleteFamilyHX    {
    familyHXId: string;
    patientAccount: string;
    practiceCode: string;
  }
